<template>
  <CContainer fluid>
    <h3>Datos de Prospecto</h3>
    <CCard class="mt-4">
      <CCardBody>
        <CTabs>
          <CTab title="Formulario de Datos">
            <CCard>
              <CCardBody class="p-4">
                <CForm>
                  <CRow>
                    <CCol col="4" sm="4">
                      <CSelect 
                      label="Tipo de Identificación" 
                      addLabelClasses="text-muted font-weight-bold"
                      :value.sync="directory.idType" 
                      :options="idTypes" 
                        :isValid="directory.idType.length > 0" 
                        @change="() => {
                          const foundType = typesIdentification.find(idType => directory.idType === idType.id_Tipo_Identificacion);
                          enableNameLastname = foundType ? foundType.activar_Nombre_Apellido === 'V' : false;

                          clearNames();
                        }" />
                    </CCol>
                    <CCol col="4" sm="4">
                      <CInput 
                        label="Identificación" 
                        addLabelClasses="text-muted font-weight-bold"
                        :value.sync="directory.id" 
                        :isValid="isIdValid" 
                        @input="() => {
                          idValidator();
                        }" 
                        @blur="() => {
                          directory.digit = calcularDv(directory.id);
                          getDataDirectory(directory.id);
                        }" />
                    </CCol>
                    <CCol sm="1">
                      <CInput 
                        label="DV" 
                        :value="directory.digit" 
                        disabled />
                    </CCol>
                    <CCol col="12" sm="12" v-if="!enableNameLastname">
                      {{ enableCompanyName }}
                      <CInput
                        label="Empresa" 
                        addLabelClasses="text-muted font-weight-bold"
                        :disabled="!enableCompanyName"
                        :value.sync="directory.companyName" 
                        :isValid="directory.companyName.length > 3" />
                    </CCol>
                    <CCol col="6" sm="6" v-if="enableNameLastname">
                      <CInput 
                        label="Primer Nombre" 
                        addLabelClasses="text-muted font-weight-bold"
                        :value.sync="directory.name1" :isValid="directory.name1.length > 0" />
                    </CCol>
                    <CCol col="6" sm="6" v-if="enableNameLastname">
                      <CInput 
                        label="Segundo Nombre" 
                        addLabelClasses="text-muted font-weight-bold"
                        :value.sync="directory.name2" />
                    </CCol>
                    <CCol col="6" sm="6" v-if="enableNameLastname">
                      <CInput 
                        label="Primer Apellido" 
                        addLabelClasses="text-muted font-weight-bold"
                        :value.sync="directory.lastName1" 
                        :isValid="directory.lastName1.length > 0" />
                    </CCol>
                    <CCol col="6" sm="6" v-if="enableNameLastname">
                      <CInput 
                        label="Segundo Apellido" 
                        addLabelClasses="text-muted font-weight-bold"
                        :value.sync="directory.lastName2" />
                    </CCol>
                    <CCol col="12" sm="12">
                      <CInput 
                        label="Dirección" 
                        addLabelClasses="text-muted font-weight-bold"
                        :value.sync="directory.address" 
                        :isValid="directory.address.length > 0" />
                    </CCol>
                    <CCol col="12" sm="12">
                      <CInput :value.sync="directory.auxAddress" />
                    </CCol>
                    <CCol col="6" sm="6">
                      <CAutocomplete 
                        required 
                        label="Ciudad" 
                        :value="directory.city" 
                        :options="cities.map(city => {
                          return {
                            value: city.id_Ciudad,
                            label: `${city.ciudad} - ${city.departamento}`
                          }
                        })" 
                        @update:input="(nvalue) => {
                          directory.city = nvalue;
                          directory.neighborhood = '';
                          neighborhoods = [];
  
                          getNeighborhoods(nvalue);
                        }">
                      </CAutocomplete>
                    </CCol>
                    <CCol col="6" sm="6">
                      <CSelect 
                        label="Barrio" 
                        :options="[
                        { value: '', label: 'Seleccionar' },
                        ...neighborhoods.map(neighborhood => {
                          return {
                            value: neighborhood.id_Barrio,
                            label: neighborhood.nombre_Barrio + ' - ' + neighborhood.localidad
                          }
                        })]" 
                        :value="directory.neighborhood" 
                        @update:input="nvalue => {
                          directory.neighborhood = nvalue
                        }" />
                    </CCol>
                    <CCol col="6" sm="6">
                      <CSelect 
                        label="Zona" 
                        :options="[
                          { value: '', label: 'Seleccionar' },
                          ...zones.map(zone => {
                            return {
                              value: zone.id_Zona,
                              label: zone.nombre_Zona
                            }
                          })
                        ]" 
                        :value.sync="directory.zone" />
                    </CCol>
                    <CCol col="4" sm="4">
                      <CInput 
                        label="Código Postal" 
                        addLabelClasses="text-muted font-weight-bold"
                        :value="directory.zipCode" 
                        @input="value => {
                          directory.zipCode = value
                        }" />
                    </CCol>
                    <CCol col="12" sm="12">
                      <CInput 
                        label="Observaciones" 
                        addLabelClasses="text-muted font-weight-bold"
                        :value.sync="directory.comments" />
                    </CCol>
                    <CCol col="4" sm="4" >
                      <CSelect 
                        label="Tipo Persona" 
                        addLabelClasses="text-muted font-weight-bold"
                        :value.sync="directory.personType" 
                        :options="[
                          { value: '1', label: 'Persona Jurídica' },
                          { value: '2', label: 'Persona Natural' }
                        ]" />
                    </CCol>
                    <CCol col="6" sm="6" >
                      <CSelect 
                        label="Responsabilidad Fiscal" 
                        addLabelClasses="text-muted font-weight-bold"
                        :value.sync="directory.fiscalDuty" 
                        :options="[
                          { value: '', label: 'Seleccionar' },
                          ...fiscalDuties.map(duty => {
                            return {
                              value: duty.id_TipoResponsabilidaFiscal,
                              label: `${duty.codigo} - ${duty.descripcion}`
                            }
                          })
                        ]" />
                    </CCol>
                    <CCol col="6" sm="6" >
                      <CSelect 
                        label="Tipo Industria" 
                        addLabelClasses="text-muted font-weight-bold"
                        :value.sync="directory.industryType" :options="[
                          { value: '', label: 'Seleccionar' },
                          ...industryTypes.map(type => {
                            return {
                              value: type.id_TipoIndustria,
                              label: `${type.codigo} - ${type.industria}`
                            }
                          })
                        ]" />
                    </CCol>
                    <CCol col="6" sm="6" >
                      <CSelect 
                        label="Tipo Clasificación Cliente" 
                        addLabelClasses="text-muted font-weight-bold"
                        :value.sync="directory.customerClassType" 
                        :options="[
                          { value: '', label: 'Seleccionar' },
                          ...customerClassTypes.map(type => {
                            return {
                              value: type.id_TipoClasificacionCliente,
                              label: type.tipo_ClasificacionCliente
                            }
                          })
                        ]" />
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
              <CCardFooter class="d-flex justify-content-center">
                <CButton 
                  color="success" 
                  class="mr-2" 
                  :class="isValidForm ? '' : 'disabled'"
                  :disabled="!isValidForm"
                  @click="save()">
                  <CIcon name="cil-check-circle" />
                  <span class="align-middle ml-2">Guardar</span>
                </CButton>
                <CButton 
                  color="danger" 
                  variant="outline"
                  :to="rootPath">
                  <CIcon name="cil-x-circle" />
                  <span class="align-middle ml-2">Cancelar</span>
                </CButton>
              </CCardFooter>
            </CCard>
          </CTab>

          <CTab title="Dependencias (Contactos)" :disabled="isCreate">
            <ContactsTab />
          </CTab>

          <CTab title="Seguimientos" :disabled="isCreate">
            <CContainer class="mt-4">
              <BusinessTracking :directoryId="idDirectory" :key="updateCompomentOpportunityTracking" />
            </CContainer>
          </CTab>

          <CTab title="Oportunidades" :disabled="isCreate">

          </CTab>

          <CTab title="Cotizaciones" :disabled="isCreate">

          </CTab>
        </CTabs>
      </CCardBody>

      <LoadingCover message="Grabando..." :size="32" v-show="loading" />
    </CCard>
  </CContainer>
</template>
<script>
  import { ref } from "vue";

  import LoadingCover from "@/components/containers/LoadingCover.vue";
  import CAutocomplete from "@/components/containers/CAutocomplete.vue";

  import BusinessTracking from "@/components/datagrids/BusinessTracking.vue";
  import ContactsTab from "@/components/datagrids/DependenciesDirectory.vue";

  import constants from "@/constants";
  import { calcularDv } from "@/digitoverifica";
  import { datosAdquiriente } from "@/apis/generics";
  import {
    dataListCiudades,
    dataListBarrios,
    dataListZonas,
    dataListTiposIdenticacion,
    dataListTiposResponsabilidadFiscal,
    dataListTiposIndustrias,
    dataListTiposClasificacionClientes,
    crearDirectorioProspecto
  } from "@/api";
  import { crudDirectorio } from "@/apiCRUD";

  export default {
    components: {
      LoadingCover,
      CAutocomplete,
      BusinessTracking,
      ContactsTab
    },
    data() {
      return {
        updateCompomentOpportunityTracking: 0,
        idDirectory: "",
        directory: {
          idType: '',
          id: '',
          digit: '',
          companyName: '',
          name1: '',
          name2: '',
          lastName1: '',
          lastName2: '',
          address: '',
          auxAddress: '',
          city: '',
          neighborhood: '',
          zone: '',
          zipCode: '',
          comments: '',
          personType: 1,
          fiscalDuty: '',
          servedBy: '',
          industryType: '',
          customerClassType: ''
        },
        cities: [],
        neighborhoods: [],
        zones: [],
        idTypes: [],
        fiscalDuties: [],
        industryTypes: [],
        customerClassTypes: [],
        enableCompanyName: false,
        enableNameLastname: false
      }
    },
    methods: {
      calcularDv,
      async getProspectData() {
        this.loading = true;

        try {
          const response = await crudDirectorio(this, "read", this.idDirectory);

          console.log(response);
          
          this.directory.idType = response.tipo_Identificacion;
          this.directory.id = response.identificacion;
          this.directory.digit = response.dv;
          this.directory.companyName = response.empresa;
          this.directory.name1 = response.nombre_01;
          this.directory.name2 = response.nombre_02;
          this.directory.lastName1 = response.apellido_01;
          this.directory.lastName2 = response.apellido_02;
          this.directory.address = response.direccion;
          this.directory.auxAddress = response.direccion_Aux;
          this.directory.city = response.ciudad;
          this.directory.neighborhood = response.barrio;
          this.directory.zone = response.zona;
          this.directory.zipCode = response.codigo_Postal;
          this.directory.comments = response.observaciones;
          this.directory.personType = response.tipo_Persona;
          this.directory.fiscalDuty = response.tipo_ResponsabilidadFiscal;
          this.directory.servedBy = response.personal;
          this.directory.industryType = response.tipo_Industria;
          this.directory.customerClassType = response.tipo_ClasificacionCliente;
        } catch(error) {
          console.error(error);
        } finally {
          this.loading = false;
        }
      },
      async getDataDirectory(directoryId) {
        try {
          const response = await crudDirectorio(this, "get", directoryId);

          this.directory.companyName = response.empresa;

          this.$store.commit("setAlert", {
            color: "danger",
            message: `Ya se encuentra registrada la empresa ${directoryId} - ${response.empresa}.`,
            show: 5
          });
        } catch(error) {
          if (error.status === 404) {
            this.getDataPurchaserDIAN();
          }
        }
      },
      async getDataPurchaserDIAN() {
        const filteres = {
          "TipoID": this.directory.idType,
          "ID": this.directory.id
        }

        try {
          const { response } = await datosAdquiriente(this, filteres);
          response.name = response.name === null ? "" : response.name;

          if (response.name.length > 0) {
            this.directory.companyName = response.name;
          } else {
            this.directory.companyName = "";
          }
        } catch (error) {
          this.directory.companyName = "";

          error;
        }
      },
      async getCities() {
        try {
          const response = await dataListCiudades(this)
          this.cities = response
        } catch (error) {
          error
        }
      },
      async getNeighborhoods(idCity) {
        try {
          const response = await dataListBarrios(this, idCity)
          this.neighborhoods = response
        } catch (error) {
          error
        }
      },
      async getZones() {
        try {
          const response = await dataListZonas(this)
          this.zones = response
        } catch (error) {
          error
        }
      },
      async getIdTypes() {
        try {
          const response = await dataListTiposIdenticacion(this);
          this.typesIdentification = response;
          this.idTypes = [
            {
                value: "",
                label: "Seleccionar"
            },
            ...response.map(item => {
              return {
                value: item.id_Tipo_Identificacion,
                label: item.identificacion
              }
            })
          ] 
        } catch (error) {
          error
        }
      },
      async getFiscalDuties() {
        try {
          const response = await dataListTiposResponsabilidadFiscal(this)
          this.fiscalDuties = response
        } catch (error) {
          error
        }
      },
      async getIndustryTypes() {
        try {
          const response = await dataListTiposIndustrias(this)
          this.industryTypes = response
        } catch (error) {
          console.error(error);
        }
      },
      async getCustomerClassTypes() {
        try {
          const response = await dataListTiposClasificacionClientes(this)
          this.customerClassTypes = response
        } catch (error) {
          console.error(error);
        }
      },
      save() {
        this.directory.servedBy = this.$store.state.user.data.id_Empleado;

        this.isCreate ? this.createDirectory() : this.updateDirectory()
      },
      async createDirectory() {
        this.loading = true;

        try {
          await crearDirectorioProspecto(this, this.directory);

          this.$router.push({ path: this.rootPath });
        } catch (error) {
          this.$store.commit("setAlert", {
            color: "danger",
            message: `Error al crear el prospecto. Error: ${error}`,
            show: 5
          });
        } finally {
          this.loading = false
        }
      },
      async updateDirectory() {
        this.loading = true;

        try {
          console.log("Proceso sin definir... MUY lindo!");
        } catch (error) {
          this.$store.commit("setAlert", {
            color: "danger",
            message: constants.messages.notDoneEdit,
            show: 5
          });
        } finally {
          this.loading = false
        }
      },
      // validate() {
      //   // const areValidNames = this.enableNameLastname ? this.areValidNames() : this.directory.companyName.length > 0
      //   // this.isValidForm = this.directory.idType.length > 0 && this.isIdValid && areValidNames && (this.directory.address.length > 0) && (this.directory.city.length > 0)
      // },
      clearNames() {
        this.directory.companyName = "";
        this.directory.name1 = "";
        this.directory.name2 = "";
        this.directory.lastName1 = "";
        this.directory.lastName2 = "";
      },
      idValidator() {
        const foundType = this.typesIdentification.find(idType => this.directory.idType === idType.id_Tipo_Identificacion)

        this.isIdValid = foundType ? foundType.minimo_Digitos_Identificacion <= this.directory.id.length && (foundType.maximo_Digitos_Identificacion >= this.directory.id.length) : false
      },
    },
    computed: {
      selectedDirectory() {
        return this.$store.state.selectedDirectory
      },
      type() {
        return this.selectedDirectory.tipo_Directorio
      },
      isValidForm() {
        const areValidNames = this.enableNameLastname ? this.areValidNames : this.directory.companyName.length > 0;

        return this.directory.idType.length > 0 && this.isIdValid && areValidNames && (this.directory.address.length > 3) && (this.directory.city.length > 0);
      },
      areValidNames() {
        return this.directory.name1.length > 3 && (this.directory.lastName1.length > 3)
      },
    },
    setup() {
      const rootPath = ref("");
      const loading = ref(false);
      const isCreate = ref(false);
      const isIdValid = ref(false);

      return {
        rootPath,
        loading,
        isCreate,
        isIdValid
      }
    },
    created() {
      this.rootPath = this.$router.currentRoute.fullPath;
      this.isCreate = this.rootPath.includes("agregar");
      
      if (this.isCreate) {
        this.rootPath = this.rootPath.replace("/agregar", "");
      } else {
        this.idDirectory = this.$router.currentRoute.params.id;
        this.updateCompomentOpportunityTracking += 1;
  
        console.log("Change Directory ", this.idDirectory);
        
        this.rootPath = this.rootPath.replace(`/editar/${this.idDirectory}`, "");
  
        this.getProspectData();
      }
  
      // // Valida que la edicion del registro solo sea para prospectos
      // if (!this.isCreate) {
      //   if (this.type !== "PP") {
      //     this.$router.push({ path: this.rootPath });
      //   }
      // }
  
      this.getCities();
      this.getZones();
      this.getIdTypes();
      this.getFiscalDuties();
      this.getIndustryTypes();
      this.getCustomerClassTypes();
    },
    mounted() {
    }
  }
</script>